import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ProjectStructureService } from 'src/app/_services/projectStructure/projectStructure.service';

@Component({
  selector: 'app-project-structure',
  templateUrl: './project-structure.component.html',
  styleUrls: ['./project-structure.component.scss']
})
export class ProjectStructureComponent implements OnInit {

  form: FormGroup;
  regionForm;
  industryForm;
  businessGroupForm;
  commodityForm;
  activityForm;
  projectSoftwareForm;
  taskForm;
  taskFilterForm;

  regionDropdown: any[] = [];
  industryDropdown: any[] = [];
  businessGroupDropdown: any[] = [];
  commodityDropdown: any[] = [];
  activityDropdown: any[] = [];
  projectSoftwareDropdown: any[] = [];
  taskDropdown: any[] = [];

  tenantId: string;
  selectedRow: any;
  currentUser: any;
  isAdministrator: boolean = false;
  isPMOAdmin: boolean = false;
  isPMOManager: boolean = false;

  rowData1: any;
  public columnDefs1: ColDef[];
  rowData2: any;
  public columnDefs2: ColDef[];
  rowData3: any;
  public columnDefs3: ColDef[];
  rowData4: any;
  public columnDefs4: ColDef[];
  rowData5: any;
  public columnDefs5: ColDef[];
  rowData6: any;
  public columnDefs6: ColDef[];
  rowData7: any;
  public columnDefs7: ColDef[];

  modeAction: number = 1 //1 - create // 2 - update
  private api: GridApi; // gridApi and columnApi  
  private columnApi: ColumnApi;
  defaultColDef: any;
  rowSelection: any;
  selectedCheckboxData = [];
  deleteConfirmationMsg = 'Are you sure you want to delete';
  deleteType: string = '';

  constructor(
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private projectStructureService: ProjectStructureService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.regionForm = new FormGroup({
      id: new FormControl(''),
      regionName: new FormControl(''),
    });

    this.industryForm = new FormGroup({
      id: new FormControl(''),
      regionId: new FormControl(''),
      regionName: new FormControl(''),
      industryName: new FormControl('')
    });

    this.businessGroupForm = new FormGroup({
      id: new FormControl(''),
      regionId: new FormControl(''),
      regionName: new FormControl(''),
      industryId: new FormControl(''),
      industryName: new FormControl(''),
      businessGroupName: new FormControl('')
    });

    this.commodityForm = new FormGroup({
      id: new FormControl(''),
      regionId: new FormControl(''),
      regionName: new FormControl(''),
      industryId: new FormControl(''),
      industryName: new FormControl(''),
      businessGroupId: new FormControl(''),
      businessGroupName: new FormControl(''),
      commodityName: new FormControl('')
    });

    this.activityForm = new FormGroup({
      id: new FormControl(''),
      activityName: new FormControl('')
    });

    this.projectSoftwareForm = new FormGroup({
      id: new FormControl(''),
      activityId: new FormControl(''),
      projectSoftwareName: new FormControl('')
    });

    this.taskForm = new FormGroup({
      id: new FormControl(''),
      activityId: new FormControl(''),
      taskDropdownName: new FormControl('')
    });

    this.taskFilterForm = new FormGroup({
      activityId: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.tenantId = this.storageService.get('tenantId');
    this.isAdministrator = this.currentUser.roles.includes('RoleAdministrator');
    this.isPMOAdmin = this.currentUser.roles.includes('RolePmoAdministrator');
    this.isPMOManager = false;
    // this.isPMOManager = this.currentUser.roles.includes('RolePmoManager');

    this.getRegion();
    this.getIndustry();
    this.getBusinessGroup();
    this.getCommodity();
    this.getActivity();
    this.getProjectSoftware();
    this.getTask();
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  createOpenRegionModal(){
    this.modeAction = 1;
    this.regionForm.reset();
    this.regionForm.patchValue({
      regionName: '',
    });
  }

  editOpenRegionModal() {
    this.modeAction = 2;
    this.regionForm.patchValue(this.selectedCheckboxData[0]);
  }

  createOpenIndustryModal(){
    this.modeAction = 1;
    this.industryForm.reset();
    this.industryForm.patchValue({
      regionId: '',
      regionName: '',
      industryName: ''
    });
  }

  editOpenIndustryModal() {
    this.modeAction = 2;
    let data = this.selectedCheckboxData[0];
    this.industryForm.patchValue({
      ...data,
      regionId: this.selectedCheckboxData[0].regionId + " . " + this.selectedCheckboxData[0].regionName
    });
  }

  createOpenBusinessGroupModal(){
    this.modeAction = 1;
    this.businessGroupForm.reset();
    this.businessGroupForm.patchValue({
      regionId: '',
      regionName: '',
      industryId: '',
      industryName: '',
      businessGroupName: ''
    });
  }

  editOpenBusinessGroupModal() {
    this.modeAction = 2;
    let data = this.selectedCheckboxData[0];
    this.getIndustryByRegion(data.regionId);
    this.businessGroupForm.patchValue({
      ...data,
      regionId: data.regionId + " . " + data.regionName,
      industryId: data.industryId + " . " + data.industryName
    });
  }

  createOpenCommodityModal(){
    this.modeAction = 1;
    this.commodityForm.reset();
    this.commodityForm.patchValue({
      regionId: '',
      regionName: '',
      industryId: '',
      industryName: '',
      businessGroupId: '',
      businessGroupName: '',
      commodityName: ''
    });
  }

  editOpenCommodityModal() {
    this.modeAction = 2;
    let data = this.selectedCheckboxData[0];
    this.getIndustryByRegion(data.regionId);
    this.getBusinessGroupByIndustry(data.industryId);
    this.commodityForm.patchValue({
      ...data,
      regionId: data.regionId + " . " + data.regionName,
      industryId: data.industryId + " . " + data.industryName,
      businessGroupId: data.businessGroupId + " . " + data.businessGroupName
    });
  }

  createOpenActivityModal(){
    this.modeAction = 1;
    this.activityForm.reset();
    this.activityForm.patchValue({
      activity: '',
    });
  }

  editOpenActivityModal() {
    this.modeAction = 2;
    this.activityForm.patchValue(this.selectedCheckboxData[0]);
  }

  createOpenProjectSoftwareModal(){
    this.modeAction = 1;
    this.projectSoftwareForm.reset();
    this.projectSoftwareForm.patchValue({
      activityId: '',
      projectSoftwareName: ''
    });
  }

  editOpenProjectSoftwareModal() {
    this.modeAction = 2;
    let data = this.selectedCheckboxData[0];
    this.projectSoftwareForm.patchValue({
      ...data,
      activityId: data.activityId + " . " + data.activityName
    });
  }

  createOpenTaskModal(){
    this.modeAction = 1;
    this.taskForm.reset();
    this.taskForm.patchValue({
      activityId: '',
      taskDropdownName: '',
    });
  }

  editOpenTaskModal() {
    this.modeAction = 2;
    let data = this.selectedCheckboxData[0];
    this.taskForm.patchValue({
      ...data,
      activityId: data.activityId + " . " + data.activityName
    });
  }

  deleteOpenModal(type) {
    this.deleteType = type;
    this.deleteConfirmationMsg = 'Are you sure you want to delete';
    for (const item of this.selectedCheckboxData) {
      switch (type) {
        case 'region':
          this.deleteConfirmationMsg += ` Region: ${item.regionName}`;
          break;
        case 'industry':
          this.deleteConfirmationMsg += ` Industry: ${item.industryName}`;
          break;
        case 'businessGroup':
          this.deleteConfirmationMsg += ` Business Group: ${item.businessGroupName}`;
          break;
        case 'commodity':
          this.deleteConfirmationMsg += ` Commodity: ${item.commodityName}`;
          break;
        case 'activity':
          this.deleteConfirmationMsg += ` Activity: ${item.activityName}`;
          break;
        case 'software':
          this.deleteConfirmationMsg += ` Project Software: ${item.projectSoftwareName}`;
          break;
        case 'task':
          this.deleteConfirmationMsg += ` Task: ${item.taskDropdownName}`;
          break;
      }
    }
  }

  deleteConfirm(){
    if (!this.deleteType || this.selectedCheckboxData.length === 0) {
      return;
    }
  
    const id = this.selectedCheckboxData[0].id;
    let deleteApi$;
  
    switch (this.deleteType) {
      case 'region':
        deleteApi$ = this.projectStructureService.deleteRegion(id);
        break;
      case 'industry':
        deleteApi$ = this.projectStructureService.deleteIndustry(id);
        break;
      case 'businessGroup':
        deleteApi$ = this.projectStructureService.deleteBusinessGroup(id);
        break;
      case 'commodity':
        deleteApi$ = this.projectStructureService.deleteCommodity(id);
        break;
      case 'activity':
        deleteApi$ = this.projectStructureService.deleteActivity(id);
        break;
      case 'software':
        deleteApi$ = this.projectStructureService.deleteProjectSoftware(id);
        break;
      case 'task':
        deleteApi$ = this.projectStructureService.deleteTaskDropdown(id);
        break;
      default:
        return;
    }
  
    deleteApi$.subscribe(() => {
      switch (this.deleteType) {
        case 'region':
          this.getRegion();
          break;
        case 'industry':
          this.getIndustry();
          break;
        case 'businessGroup':
          this.getBusinessGroup();
          break;
        case 'commodity':
          this.getCommodity();
          break;
        case 'activity':
          this.getActivity();
          break;
        case 'software':
          this.getProjectSoftware();
          break;
        case 'task':
          this.getTask();
          break;
      }
      this.selectedCheckboxData = [];
      this.deleteType = '';
      this.deleteConfirmationMsg = '';
      $('#closeModalDelete').trigger("click");
    });
  }

  getRegion(){
    this.regionDropdown = [];
    this.columnDefs1= [
      { 
        headerName: 'Region',
        field: 'regionName',
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn
      }
    ];
    this.projectStructureService.getRegion().subscribe((response: any) => {
      this.rowData1 = response;
      for (let item of response) {
        this.regionDropdown.push(`${item.id} . ${item.regionName}`);
      }
    });
  }

  createRegion() {
    let details = {
      regionName: this.regionForm.get('regionName').value,
    }

    this.projectStructureService.createRegion(details).subscribe((response: any) => {
      this.getRegion();
      $('#closeModalRegion').trigger("click");
    });
  }

  updateRegion() {
    let details = {
      regionName: this.regionForm.get('regionName').value,
    }

    this.projectStructureService.updateRegion(this.selectedCheckboxData[0].id, details).subscribe((response: any) => {
      this.getRegion();
      this.getIndustry();
      this.getBusinessGroup();
      this.getCommodity();
      $('#closeModalRegion').trigger("click");
    });
  }

  getIndustry(){
    this.columnDefs2= [
      { headerName: 'Region', field: 'regionName', headerCheckboxSelection: this.isFirstColumn, checkboxSelection: this.isFirstColumn},
      { headerName: 'Industry', field: 'industryName'},
    ];
    this.projectStructureService.getIndustry().subscribe((response: any) => {
      this.rowData2 = response;
    });
  }

  getIndustryByRegion(params){
    let regionId: any
    if(this.modeAction === 1){
      regionId = params.target.value.split(' . ')[0];
    } else {
      regionId = params;
    }
    
    this.industryDropdown = [];
    this.projectStructureService.getIndustryByRegion(regionId).subscribe((response: any) => {
      for (let item of response) {
        this.industryDropdown.push(`${item.id} . ${item.industryName}`);
      }
    });
  }

  createIndustry() {
    let details = {
      regionId: this.industryForm.get('regionId').value.split(' . ')[0],
      industryName: this.industryForm.get('industryName').value,
    }

    this.projectStructureService.createIndustry(details).subscribe((response: any) => {
      this.getIndustry();
      $('#closeModalIndustry').trigger("click");
    });
  }

  updateIndustry() {
    let details = {
      regionId: this.industryForm.get('regionId').value.split(' . ')[0],
      industryName: this.industryForm.get('industryName').value,
    }

    this.projectStructureService.updateIndustry(this.selectedCheckboxData[0].id, details).subscribe((response: any) => {
      this.getIndustry();
      this.getBusinessGroup();
      this.getCommodity();
      $('#closeModalIndustry').trigger("click");
    });
  }

  getBusinessGroup(){
    this.columnDefs3= [
      { headerName: 'Region', field: 'regionName', headerCheckboxSelection: this.isFirstColumn, checkboxSelection: this.isFirstColumn},
      { headerName: 'Industry', field: 'industryName'},
      { headerName: 'Business Group', field: 'businessGroupName'},
    ];
    this.projectStructureService.getBusinessGroup().subscribe((response: any) => {
      this.rowData3 = response;
    });
  }

  getBusinessGroupByIndustry(params){
    let industryId: any
    if(this.modeAction === 1){
      industryId = params.target.value.split(' . ')[0];
    }
    else{
      industryId = params;
    }
      
    this.businessGroupDropdown = [];
    this.projectStructureService.getBusinessGroupByIndustry(industryId).subscribe((response: any) => {
      for (let item of response) {
        this.businessGroupDropdown.push(`${item.id} . ${item.businessGroupName}`);
      }
    });
  }

  createBusinessGroup() {
    let details = {
      regionId: this.businessGroupForm.get('regionId').value.split(' . ')[0],
      industryId: this.businessGroupForm.get('industryId').value.split(' . ')[0],
      businessGroupName: this.businessGroupForm.get('businessGroupName').value,
    }

    this.projectStructureService.createBusinessGroup(details).subscribe((response: any) => {
      this.getBusinessGroup();
      $('#closeModalBusinessGroup').trigger("click");
    });
  }

  updateBusinessGroup() {
    let details = {
      regionId: this.businessGroupForm.get('regionId').value.split(' . ')[0],
      industryId: this.businessGroupForm.get('industryId').value.split(' . ')[0],
      businessGroupName: this.businessGroupForm.get('businessGroupName').value,
    }

    this.projectStructureService.updateBusinessGroup(this.selectedCheckboxData[0].id, details).subscribe((response: any) => {
      this.getBusinessGroup();
      this.getCommodity();
      $('#closeModalBusinessGroup').trigger("click");
    });
  }

  getCommodity(){
    this.columnDefs4= [
      { headerName: 'Region', field: 'regionName', headerCheckboxSelection: this.isFirstColumn, checkboxSelection: this.isFirstColumn},
      { headerName: 'Industry', field: 'industryName'},
      { headerName: 'Business Group', field: 'businessGroupName'},
      { headerName: 'Commodity', field: 'commodityName'},
    ];
    this.projectStructureService.getCommodity().subscribe((response: any) => {
      this.rowData4 = response;
    });
  }

  // getCommodityByBusinessGroup(){
  //   this.projectStructureService.getCommodityByBusinessGroup(this.industryForm.get('businessGroupId').value().split(' . ')[0]).subscribe((response: any) => {
      
  //   });
  // }

  createCommodity() {
    let details = {
      regionId: this.commodityForm.get('regionId').value.split(' . ')[0],
      industryId: this.commodityForm.get('industryId').value.split(' . ')[0],
      businessGroupId: this.commodityForm.get('businessGroupId').value.split(' . ')[0],
      commodityName: this.commodityForm.get('commodityName').value,
    }

    this.projectStructureService.createCommodity(details).subscribe((response: any) => {
      this.getCommodity();
      $('#closeModalCommodity').trigger("click");
    });
  }

  updateCommodity() {
    let details = {
      regionId: this.commodityForm.get('regionId').value.split(' . ')[0],
      industryId: this.commodityForm.get('industryId').value.split(' . ')[0],
      businessGroupId: this.commodityForm.get('businessGroupId').value.split(' . ')[0],
      commodityName: this.commodityForm.get('commodityName').value,
    }

    this.projectStructureService.updateCommodity(this.selectedCheckboxData[0].id, details).subscribe((response: any) => {
      this.getCommodity();
      $('#closeModalCommodity').trigger("click");
    });
  }

  getActivity(){
    this.activityDropdown = [];
    this.columnDefs5= [
      { headerName: 'Activity', field: 'activityName', headerCheckboxSelection: this.isFirstColumn, checkboxSelection: this.isFirstColumn},
    ];
    this.projectStructureService.getActivity().subscribe((response: any) => {
      this.rowData5 = response;
      for (let item of response) {
        this.activityDropdown.push(`${item.id} . ${item.activityName}`);
      }
    });
  }

  createActivity() {
    let details = {
      activityName: this.activityForm.get('activityName').value,
    }

    this.projectStructureService.createActivity(details).subscribe((response: any) => {
      this.getActivity();
      $('#closeModalActivity').trigger("click");
    });
  }

  updateActivity() {
    let details = {
      activityName: this.activityForm.get('activityName').value,
    }

    this.projectStructureService.updateActivity(this.selectedCheckboxData[0].id, details).subscribe((response: any) => {
      this.getActivity();
      this.getProjectSoftware();
      $('#closeModalActivity').trigger("click");
    });
  }

  getProjectSoftware(){
    this.columnDefs6= [
      { headerName: 'Activity', field: 'activityName', headerCheckboxSelection: this.isFirstColumn, checkboxSelection: this.isFirstColumn},
      { headerName: 'Project Software', field: 'projectSoftwareName'},
    ];
    this.projectStructureService.getProjectSoftware().subscribe((response: any) => {
      this.rowData6 = response;
    });
  }

  // getProjectSoftwareByActivity(){
  //   this.projectStructureService.getBusinessGroupByIndustry(this.industryForm.get('activityId').value().split(' . ')[0]).subscribe((response: any) => {
  //     for (let item of response) {
  //       this.projectSoftwareDropdown.push(`${item.id} . ${item.projectSoftwareName}`);
  //     }
  //   });
  // }

  createProjectSoftware() {
    let details = {
      activityId: this.projectSoftwareForm.get('activityId').value.split(' . ')[0],
      projectSoftwareName: this.projectSoftwareForm.get('projectSoftwareName').value,
    }

    this.projectStructureService.createProjectSoftware(details).subscribe((response: any) => {
      this.getProjectSoftware();
      $('#closeModalSoftware').trigger("click");
    });
  }

  updateProjectSoftware() {
    let details = {
      activityId: this.projectSoftwareForm.get('activityId').value.split(' . ')[0],
      projectSoftwareName: this.projectSoftwareForm.get('projectSoftwareName').value,
    }

    this.projectStructureService.updateProjectSoftware(this.selectedCheckboxData[0].id, details).subscribe((response: any) => {
      this.getProjectSoftware();
      $('#closeModalSoftware').trigger("click");
    });
  }

  getTask(){
    this.columnDefs7= [
      { headerName: 'Activity', field: 'activityName', headerCheckboxSelection: this.isFirstColumn, checkboxSelection: this.isFirstColumn},
      { headerName: 'Task', field: 'taskDropdownName'},
    ];
    this.projectStructureService.getTaskDropdown().subscribe((response: any) => {
      this.rowData7 = response;
    });
  }

  createTask() {
    let details = {
      activityId: parseInt(this.taskForm.get('activityId').value.split(' . ')[0]),
      taskDropdownName: this.taskForm.get('taskDropdownName').value,
    }

    this.projectStructureService.createTaskDropdown(details).subscribe((response: any) => {
      this.getTask();
      $('#closeModalTask').trigger("click");
    });
  }

  updateTask() {
    let details = {
      activityId: parseInt(this.taskForm.get('activityId').value.split(' . ')[0]),
      taskDropdownName: this.taskForm.get('taskDropdownName').value,
    }

    this.projectStructureService.updateTaskDropdown(this.selectedCheckboxData[0].id, details).subscribe((response: any) => {
      this.getTask();
      $('#closeModalTask').trigger("click");
    });
  }

  getTaskByActivity(){
    this.projectStructureService.getTaskDropdownByActivity(this.taskFilterForm.get('activityId').value.split(' . ')[0]).subscribe((response: any) => {
      this.rowData7 = response;
    });
  }

}